import { Heading, HStack, Stack, Text, useBreakpointValue } from '@chaine/keychaine';
import React from 'react';
const Category = (props) => {
    const { category } = props;
    return (React.createElement(Text, { fontSize: useBreakpointValue({ base: '2xl', md: '28px' }), fontWeight: "medium", color: "text.primary" }, category));
};
const Title = (props) => {
    const { title, titleColor } = props;
    return (React.createElement(Heading, { color: titleColor, size: useBreakpointValue({ base: 'xl', md: 'xl', lg: '2xl' }), fontWeight: "medium" }, title));
};
export const SectionTitle = (props) => {
    const { category, titleColor, subtext, title } = props;
    return (React.createElement(Stack, { spacing: 2 },
        React.createElement(HStack, null,
            React.createElement(Category, { category: category })),
        React.createElement(Title, { title: title, titleColor: titleColor }),
        React.createElement(Heading, { color: "text.primary", size: useBreakpointValue({ base: 'xl', md: 'xl', lg: '2xl' }), fontWeight: "medium", lineHeight: "shorter" }, subtext)));
};
